import { useTranslation } from 'react-i18next';
import type { IQuoteGroup, IQuoteOption } from '@interfaces/IFinance';
import { fmtUsdThousandsInt } from '../format';
import styles from './QuotesTab.module.css';

interface IQuotesTabProps {
  quotes: IQuoteGroup[];
}

export function QuotesTab({ quotes }: IQuotesTabProps) {
  const { t } = useTranslation();

  return (
    <>
      {quotes.map((group) => (
        <section key={group.id} className={styles.group}>
          <header className={styles.groupHead}>
            <h2 className={styles.groupTitle}>{group.title}</h2>
            <span className={styles.groupBudget}>
              {t('finance.quotes.budgetLabel', { value: fmtUsdThousandsInt(group.budgetUsd) })}
            </span>
          </header>

          <div className={styles.cards}>
            {group.options.map((opt) => (
              <QuoteCard key={opt.id} opt={opt} />
            ))}
          </div>
        </section>
      ))}
    </>
  );
}

function QuoteCard({ opt }: { opt: IQuoteOption }) {
  const { t } = useTranslation();

  return (
    <article className={`${styles.card} ${opt.selected ? styles.cardSelected : ''}`}>
      <header className={styles.cardHead}>
        <span className={styles.supplier}>{opt.supplier}</span>
        {opt.selected ? (
          <span className={styles.tick} role="img" aria-label={t('finance.quotes.selectedAria')}>
            ✓
          </span>
        ) : null}
      </header>
      <div className={`${styles.price} ${styles[`tone_${opt.tone}`]}`}>
        {fmtUsdThousandsInt(opt.priceUsd)}
      </div>
      <div className={styles.lead}>{`Lead: ${opt.leadLabel}`}</div>
      <div className={styles.scope}>{opt.scopeNote}</div>
      {opt.selected ? (
        <span className={styles.selectedPill}>{t('finance.quotes.selected')}</span>
      ) : (
        <button
          type="button"
          className={styles.selectBtn}
          aria-label={t('finance.quotes.selectQuoteAria', { supplier: opt.supplier })}
        >
          {t('finance.quotes.selectQuote')}
        </button>
      )}
    </article>
  );
}
